<template>
    <main class="container-fluid">
      <section class="row">
        <div class="col-4 px-3 py-3 d-none d-md-flex"></div>
        <div class="col-md-16 px-3 py-3 ">
          <div class="col d-column">
            <h1 class="title pt-2 mb-0" v-text="$ml.get('scoreHistory')">Histórico de pontuação</h1>
            <h1 class="title">
              <span class="pb-2" v-text="$ml.get('manageYourProgressPlatform')">Gerencie seu progresso na plataforma BugHunt</span>
            </h1>
            <div class="card mb-3">
              <div class="card-body">
                <div class="d-column flex-row">
                  <div class="loading d-flex ">
                    <div v-if="loading" class="c-loader"></div> 
                  </div>
                  
                 <div v-if="!loading" class="d-column" >
                   <div class="h-profile no h-profile-lg d-flex flex-column pb-3 align-items-start" >
                    <div class="d-flex align-self-start d-flex flex-column align-items-start w-100 mb-2" >
                      <div class="v-line-full"><span></span></div>
                      <div class="d-flex align-self-start d-flex flex-row align-items-start justify-content-start w-100 z-fix" >
                        <object width="62" height="62" class="rounded-circle img-lg mr-3" :data="person.avatar" type="image/png" >
                          <img width="62" height="62" class="rounded-circle img-lg mr-3" src="../../../assets/images/default.png" alt="Avatar" />
                        </object>
                        <div class="d-flex w-100">
                          <div class="align-self-start mt-1 w-100">
                            <h3 class="pb-1" >
                              <div class="link-block" >
                                <strong>{{person.username}}</strong>
                              </div>
                            </h3> 
                            
                            <p class="d-flex align-items-center pb-2">
                              <span class="align-self-center">
                                {{$ml.get('joinedThePlatform') + ' ' + $ml.with($utils.formatData(person.createdAt, $ml.get('ln'))).get('ago')}}
                              </span>
                            </p>
 
                            <hr />
                            <div class="card-chart-body card-chart-body-lg w-100">
                              <div class="row"> 
                                <div class="col-12 col-md-3 border-r-d mt-2 mb-2">
                                  <span class="pb-1" v-text="$ml.get('reports')" >Relatórios</span >
                                  <h6>{{total_reports}}</h6>
                                </div>
                                <div class="col-12 col-md-5  pl-3 mt-2 mb-2">
                                  <span class="pb-1" v-text="$ml.get('closedReports')">Encerrados</span >
                                  <h6>{{closed_reports}}</h6>
                                </div>  
                              </div>
                              <hr />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="d-flex align-self-start h-profile-circle pb-4" >
                      <div class="circle d-flex justify-content-center"> 
                        <div class="h-line"><span></span></div>
                      </div>
                      <div class="pl-3 d-flex w-100 align-items-center">
                        <div class="d-flex flex-row align-items-start w-100 pointer" >
                          <span class="mr-2 align-self-start">Total <b class="text-lowercase">{{person.score}} {{$ml.get('points')}}</b></span>
                        </div>
                      </div>
                    </div>

                    <transition-group name="list" > 
                      <div v-for="(item, index) in score_history" :key="index + 'reports'" class="list-item mt-2">
                        <div  class="d-flex align-self-start h-profile-circle" > 
                          <div class="circle d-flex justify-content-center "> 
                            <span class="circle-internal d-flex justify-content-center">
                              <span class="circle-pending closed"></span>
                            </span>
                            <div class="h-line"><span></span></div>
                          </div>

                          <div class="pl-3 d-flex w-100 align-items-center">
                            <router-link :to="'/report/details?' + item.report_id" class="d-flex flex-row align-items-start w-100 pointer" >
                              <a class="badge badge-warning mr-2 align-self-start closed" >#{{ item.report_id }}</a >
                              <Impact :impact="'impact-' + item.severity" class="mt-1 mr-1" />
                              <p class="align-self-center">
                                <a class="link-block" v-text="item.score + ' pontos'"></a>
                              </p>
                            </router-link>
                          </div> 
                        </div>

                        <div  class="d-flex align-self-start h-profile-circle pt-2" >

                          <div class="circle d-flex justify-content-center">  
                            <div><span></span></div>
                          </div>

                          <div class="pl-3 pb-4 d-flex w-100 align-items-center">
                            <div class="d-flex flex-row align-items-start w-100 pointer" > 
                              <p class="align-self-center">
                                <a class="link-block">
                                  {{$ml.get('closedIn')}} <b>{{ $utils.formatDataShort(item.closed_at) }}</b> {{$ml.get('as')}} <b>{{$ml.get(item.situation)}}</b></a>
                              </p> 
                            </div>
                          </div> 
                        </div> 
                      </div>  
                    </transition-group>
                    
                      <div class="d-flex align-self-start h-profile-circle" >
                        <div class="circle d-flex justify-content-center">
                          <div class="h-line"><span></span></div>
                        </div>
                        <div class="pl-3 d-flex w-100 align-items-center">
                          <div class="d-flex flex-row align-items-start w-100 pointer">
                            <b class="mx-1">{{person.initial_score}} </b> {{$ml.get('pointsIn')}}
                          <h6 class="align-self-center">
                            <a class="link-block px-1"> {{$utils.formatDataShort(person.score_initial_date)}}</a>
                          </h6>
                          </div>
                        </div>
                      </div> 
                   
                    </div>
  
                  </div>
  
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>   
</template>

<script>

import ReportService from "../../../services/report.service";

export default { 
  data() {
    return { 
      reports: [
        {"_id":"62bc09399d78ca58265731d1",
          "status":"closed",
          "points": 20 ,
          "severity":"low",
          "createdAt":"2022-06-25T08:11:37.908Z"},
        
        {"_id":"62bc091b9d78ca58265731cb",
        "status":"closed",
        "points": 20 ,
        "severity":
        "medium",
        "createdAt":"2022-01-29T08:11:07.630Z"},

        {"_id":"62bc079f9d78ca58265731c5",
          "status":"closed",
          "points": 20 ,
          "severity":"low",
          "createdAt":"2022-06-17T08:04:47.917Z"},

        {"_id":"62bc07869d78ca58265731bf",
          "status":"closed",
          "points": 20 ,
          "severity":"low",
          "createdAt":"2022-06-22T08:04:22.128Z"},

        {"_id":"62bc05ab9d78ca58265731b3",
          "status":"closed",
          "points": 20 ,
          "severity":"medium",
          "createdAt":"2022-06-29T07:56:27.192Z"}
      ], 

      person: [],
      score_history: [],
      closed_reports: 0,
      total_reports: 0,
      points: 350,
      loading: false,
      position: 0,

    };
  },
  mounted() {
   this.rankingCompany();
  },
  methods: {
    rankingCompany() {
      this.loading = true;

      ReportService.getScoreHistory().then(
        (response) => {
          let resp = response.data
          this.closed_reports = resp.closed_reports
          this.total_reports = resp.total_reports
          this.score_history = resp.score_history 
          this.person = resp.person 
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
    },
  }
};
</script>
<style scoped>
.closed {
  background-color: #28a745 !important;
  color: #fff;
  background-color: #28a745;
} 
</style>
